export default __webpack_public_path__ + "static/logo-155e108992c26360406003b84037a009.png";